export enum PlanType {
  FREE = "FREE",
  PASSIVE_RESEARCH = "PASSIVE_RESEARCH",
  ACTIVE_RESEARCH = "ACTIVE_RESEARCH",
}

export enum PlanStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  EXPIRED = "EXPIRED",
}

export type StripeCancellationFeedback =
  | "customer_service"
  | "low_quality"
  | "missing_features"
  | "other"
  | "switched_service"
  | "too_complex"
  | "too_expensive"
  | "unused";

export interface CancelPlanInput {
  reason?: StripeCancellationFeedback;
  comment?: string;
}

export interface CancelPlanPayload {
  feedback?: StripeCancellationFeedback;
  comment?: string;
}

export interface PlanSubscriptionMutationResponse {
  stripeSubscriptionId: string;
  status: string;
  priceId: string;
  productId: string;
  currentPeriodStart: string;
  currentPeriodEnd: string;
  cancelAt: string | null;
  cancelAtPeriodEnd: boolean;
  canceledAt: string | null;
  isActive: boolean;
  willCancelAtPeriodEnd: boolean;
  canCancel: boolean;
  canReactivate: boolean;
}

export enum Feature {
  CVPARSE = "CVPARSE",
  CVENHANCE = "CVENHANCE",
  CVTEMPLATE = "CVTEMPLATE",
  COVERLETTER = "COVERLETTER",
  INTERVIEWER = "INTERVIEWER",
  NOTIFICATION = "NOTIFICATION",
  EXAMPLE = "EXAMPLE",
}

export interface FeatureDetails {
  feature: Feature;
  usedCredits: number;
  isActive?: boolean;
  availableCredits?: number;
}

export interface ScheduledChange {
  effectiveDate: string; // ISO8601 format
  scheduleId: string;
  targetPlanType: PlanType;
}

export interface Plan {
  planType: PlanType;
  features: FeatureDetails[];
  usedCredits: number;
  lastUsedDate?: string; // ISO8601 format, optional
  createdAt?: string; // ISO8601 format, optional
  updatedAt?: string; // ISO8601 format, optional
  renovationDate?: string; // ISO8601 format, optional
  scheduledChange?: ScheduledChange;
  isActive?: boolean;
  status?: PlanStatus;
  cancelAtPeriodEnd?: boolean;
}

export type GetPlanResponse = Plan;
